import { z } from 'zod';

import i18n from '@/lib/i18n/i18n';

const { t } = i18n;

const NAME_MIN_LENGTH = 3;
const NAME_MAX_LENGTH = 100;
const BUSINESS_UNIT_MIN_LENGTH = 3;
const BUSINESS_UNIT_MAX_LENGTH = 100;
const DESCRIPTION_MIN_LENGTH = 10;

export const requestProjectValidationSchema = z.object({
  name: z
    .string()
    .nonempty(t`default:fieldIsRequired`)
    .min(
      NAME_MIN_LENGTH,
      t('default:minLengthError', {
        minLengthValue: NAME_MIN_LENGTH,
      }),
    )
    .max(
      NAME_MAX_LENGTH,
      t('default:maxLengthError', {
        maxLengthValue: NAME_MAX_LENGTH,
      }),
    ),
  email: z
    .string()
    .nonempty(t`default:fieldIsRequired`)
    .email(t`contacts:forms.errors.invalidEmailAddress`),
  businessUnit: z
    .string()
    .nonempty(t`default:fieldIsRequired`)
    .min(
      BUSINESS_UNIT_MIN_LENGTH,
      t('default:minLengthError', {
        minLengthValue: BUSINESS_UNIT_MIN_LENGTH,
      }),
    )
    .max(
      BUSINESS_UNIT_MAX_LENGTH,
      t('default:maxLengthError', {
        maxLengthValue: BUSINESS_UNIT_MAX_LENGTH,
      }),
    ),
  description: z
    .string()
    .nonempty(t`default:fieldIsRequired`)
    .min(
      DESCRIPTION_MIN_LENGTH,
      t('default:minLengthError', {
        minLengthValue: DESCRIPTION_MIN_LENGTH,
      }),
    ),
});

export type RequestProjectFormFields = z.infer<
  typeof requestProjectValidationSchema
>;
